import React from "react";
import { X } from "lucide-react";

interface XButtonProps {
  onClick: () => void;
  label: string;
  size?: number;
  className?: string;
}

/**
 * Shared "X" icon button used for closing modals/drawers and removing rows
 * (cart line items, admin form images/sizes). Centralizes the icon markup
 * that used to be a hand-written <svg> copy-pasted in ~10 places.
 */
const XButton: React.FC<XButtonProps> = ({
  onClick,
  label,
  size = 20,
  className = "text-ks-secondary hover:text-ks-text p-1",
}) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    className={`transition-colors ${className}`}
  >
    <X size={size} strokeWidth={1.5} />
  </button>
);

export default XButton;
